'use es6';

import { Component } from 'react';
import { ReactReduxContext } from 'react-redux';
import InpageMessenger from 'ContentEditorUI/lib/inpage/InpageMessenger';
import { captureMessage } from 'ContentEditorUI/lib/exceptions';
import { jsx as _jsx } from "react/jsx-runtime";
export default class InpageMessengerContainer extends Component {
  // Initialize communication between app and preview iframe.
  componentDidMount() {
    const previewElement = document.getElementById('contentEditor-preview');
    InpageMessenger.setStore(this.storeRef);
    if (previewElement) {
      InpageMessenger.create(previewElement.contentWindow);
    } else {
      captureMessage('Tried creating inpage messenger before iframe rendered');
    }
  }
  saveStoreRefAndReturnNull(store) {
    this.storeRef = store;
    return null;
  }
  render() {
    return /*#__PURE__*/_jsx(ReactReduxContext.Consumer, {
      children: ({
        store
      }) => this.saveStoreRefAndReturnNull(store)
    });
  }
}